export default __webpack_public_path__ + "static/media/Class_of_72.9c83f975.jpg";